import Dialog from 'quasar/src/plugins/Dialog.js';
import { round } from 'src/helpers/docRows'

const getAll = (fn, rows) => round(rows.reduce((tot, row) => tot + fn(row), 0))

const getTotal = ({ Quantita, price = 0, product_row: { iso_price = 0 } }) => round(Quantita * (price * 1 + iso_price))
const getPrivato = ({ Quantita, price = 0 }) => round(price * Quantita)
const getSocial = ({ Quantita, product_row: { iso_price = 0 } }) => round(iso_price * Quantita)
const getImp = ({ Quantita, price = 0, Iva = 0, product_row: { iso_price = 0 } }) => round(100 * Quantita * (price * 1 + iso_price) / (Iva * 1 + 100))
const getIva = ({ Quantita, price = 0, Iva = 0, product_row: { iso_price = 0 } }) => round(Iva * Quantita * (price * 1 + iso_price) / (Iva * 1 + 100))

export default {
  namespaced: true,

  modules: {
    docRow: {
      namespaced: true,

      state: {
        row: { product: {}, prostetic: {}, product_row: {}, practice: {}, Quantita: 1 },
        editing: false,
      },

      getters: {
        total: ({ row }) => (param = row) => getTotal(param),
        privato: ({ row }) => (param = row) => getPrivato(param),
        social: ({ row }) => (param = row) => getSocial(param),
        imp: ({ row }) => (param = row) => getImp(param),
        iva: ({ row }) => (param = row) => getIva(param),
      },

      mutations: {
        clear(state) {
          state.editing = false
          state.row = { product: {}, prostetic: {}, product_row: {}, practice: {}, Quantita: 1 }
        },
        setRow(state, row) {
          state.editing = true
          state.row = row
        },
        updateRow(state, row) {
          state.row = { ...state.row, ...row }
        },
      },
    },
  },

  state: {
    rows: [],
  },

  getters: {
    total: ({ rows }) => getAll(getTotal, rows),
    privato: ({ rows }) => getAll(getPrivato, rows),
    social: ({ rows }) => getAll(getSocial, rows),
    imp: ({ rows }) => getAll(getImp, rows),
    iva: ({ rows }) => getAll(getIva, rows),
  },

  actions: {
    storeRow({ commit, state: { docRow: { row } } }) {
      commit('storeRow', row)
      commit('docRow/clear')
    },
    updateRow({ commit, state: { docRow: { row } } }, idx) {
      commit('updateRow', { idx, ...row })
      commit('docRow/clear')
    },
    updateOrAdd({ commit, state }, rows) {
      if (state.rows.length === 0) commit('setRows', rows)
      else {
        Dialog.create({
          title: 'Attenzione',
          message: 'Vuoi sostituire le righe esistenti o aggiungerle alla lista?',
          persistent: true,
          cancel: 'Sostituisci',
          ok: 'Aggiungi',
        }).onOk(() => { commit('setRows', [...state.rows, ...rows]) })
          .onCancel(() => { commit('setRows', rows) })
      }
    },
  },

  mutations: {
    clear(state) { state.rows = [] },
    setRows(state, rows) {
      state.rows = rows.map(({ product, prostetic, product_row, practice, Quantita = 1, fk_articoli, Fk_Articoli, fk_Articoli, ...row }) => ({
        ...row,
        Quantita,
        fk_Articoli: fk_Articoli || fk_articoli || Fk_Articoli,
        prostetic: prostetic || {},
        product: product || {},
        product_row: product_row || {},
        practice: practice || {},
      }))
    },

    storeRow(state, { product, prostetic, product_row, practice, Quantita = 1, fk_articoli, Fk_Articoli, fk_Articoli, ...row }) {
      state.rows.push({
        ...row,
        Quantita,
        fk_Articoli: fk_Articoli || fk_articoli || Fk_Articoli,
        prostetic: prostetic || {},
        product: product || {},
        product_row: product_row || {},
        practice: practice || {},
      })
    },
    // updateRow (state, { idx, row }) { state.rows.splice(idx, 1, row) },
    updateRow(state, { idx, ...props }) { state.rows.splice(idx, 1, { ...state.rows[idx], ...props }) },
    destroyRow(state, idx) { state.rows.splice(idx, 1) },
  },
}
